/**
 * Shared GET /profiles/me/ cache.
 * App chrome, ProGate, and the account hub share one in-flight request
 * and reuse the payload for the tab session until a write or logout.
 */

export const PROFILE_ME_PATH = '/profiles/me/';

let cached = null;
let inFlight = null;

export function getCachedProfile(_options = {}) {
  if (!cached?.data) return null;
  return cached.data;
}

export function setCachedProfile(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return;
  cached = { data, ts: Date.now() };
}

export function patchCachedProfile(partial) {
  if (!partial || typeof partial !== 'object' || Array.isArray(partial)) return;
  setCachedProfile({ ...(cached?.data || {}), ...partial });
}

export function invalidateProfileCache() {
  cached = null;
  inFlight = null;
}

export function fetchProfile(client, { force = false } = {}) {
  if (!client || typeof client.get !== 'function') {
    return Promise.reject(new Error('api client required'));
  }
  if (!force) {
    const fresh = getCachedProfile();
    if (fresh) return Promise.resolve({ data: fresh });
  }
  if (inFlight) return inFlight;

  inFlight = client
    .get(PROFILE_ME_PATH)
    .then((res) => {
      if (res?.data) setCachedProfile(res.data);
      return res;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}
